import React from 'react';
import { Dimmer, Loader } from 'semantic-ui-react';
import styles from './loading.less';
export function Loading(_a) {
    var active = _a.active;
    return React.createElement(Dimmer, { active: active, inverted: true, className: styles.dimmer },
        React.createElement(Loader, null));
}
